import React from "react";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { accountName } from "../../store";
import { color, flexCenterDir } from "../../style/theme";

const IssuesList = ({ currentPosts }: any) => {
	const [account, setAccount] = useRecoilState(accountName);

	return (
		<ListSection>
			<div>
				<span></span>
			</div>

			{currentPosts.map((data: any) => {
				return (
					<ListItem key={`${data.repo}/${data.number}`}>
						<RowBox>
							<h3>
								{account}/{data.repo}
							</h3>
							<img
								className="share"
								src={`/images/share.svg`}
								alt="Share"
								onClick={() => window.open(data.html_url)}
							/>
						</RowBox>

						<RowBox>
							<h2>
								{data.title}
								<span>#{data.number}</span>
							</h2>
						</RowBox>

						<RowBox>
							<div className="state">{data.state}</div>
							<span>Comments: {data.comments}</span>
						</RowBox>
					</ListItem>
				);
			})}
		</ListSection>
	);
};

const ListSection = styled.ul`
	${flexCenterDir}

	width: 50rem;
`;

const ListItem = styled.li`
	${flexCenterDir}

	width: 100%;
	padding: 1rem;
	margin-bottom: 1rem;
	background: ${color.gray};
	border-radius: 18px;
	transition: all 0.3s ease 0s;

	&:hover {
		box-shadow: 0px 1px 20px ${color.gray};
		transform: translateY(-2px);
	}
`;

const RowBox = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	margin-bottom: 1rem;

	h3 {
		color: ${color.blue};
		font-weight: 400;
	}

	img {
		width: 27px;
		cursor: pointer;
	}

	h2 {
		margin-bottom: 1rem;

		span {
			color: gray;
			font-weight: 400;
			margin-left: 1rem;
		}
	}

	.state {
		border-radius: 14px;
		background: ${color.point};
		padding: 0.3rem 1rem;
		margin-right: 1rem;
	}
`;

export default React.memo(IssuesList);
